import { Record } from "immutable";

export type TrialStateType = {
  remaining: number;
  total: number;
};

const defaultTrialState: TrialStateType = {
  remaining: 0,
  total: 0
};

export default class TrialState extends Record(defaultTrialState) {}
